var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('el-alert',{attrs:{"title":"感謝您的預訂，報名確認信將於3日內寄出，期待與您相見：)","type":"success","show-icon":"","closable":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }